namespace TabAurous.OMS {
    export namespace MetalRateMasterService {
        export const baseUrl = 'OMS/MetalRateMaster';

        export declare function Create(request: Serenity.SaveRequest<MetalRateMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<MetalRateMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<MetalRateMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<MetalRateMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetMetalRate(request: RateRequest, onSuccess?: (response: Serenity.ListResponse<MetalRateMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "OMS/MetalRateMaster/Create",
            Update = "OMS/MetalRateMaster/Update",
            Delete = "OMS/MetalRateMaster/Delete",
            Retrieve = "OMS/MetalRateMaster/Retrieve",
            List = "OMS/MetalRateMaster/List",
            GetMetalRate = "OMS/MetalRateMaster/GetMetalRate"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'GetMetalRate'
        ].forEach(x => {
            (<any>MetalRateMasterService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
